/**
 * O aviso das telas que gravam **dado global**.
 *
 * Dado global é o que não pertence a um projeto: sistema, fabricante, cor de
 * função, projeto de correias. Mudar um deles muda em todos os projetos de uma
 * vez — e é por isso que **em desenvolvimento a trava só deixa passar registro
 * de teste**: o canário 992 protege o módulo de pinout porque ali existe um
 * projeto de brinquedo, mas para dado global não existe equivalente, e a API
 * aponta para produção.
 *
 * A porta que existe é o prefixo `ZZTESTE`: criar um registro marcado assim
 * passa, alterar a Fiat não. É o que permitiu exercitar estes caminhos, que
 * nunca tinham sido exercitados nem uma vez — o porquê está em `api/trava.ts`.
 *
 * A tela avisa antes, em vez de deixar a pessoa preencher um formulário inteiro
 * e levar um erro no fim. No ar, onde a trava não existe, tudo funciona — e o
 * aviso some junto com ela.
 */

import { travaLigada } from "@/api/cliente"

export function AvisoDeDadoGlobal({ oQueMuda }: {
  /** O que exatamente muda em todos os projetos. Frase curta, no plural. */
  oQueMuda: string
}) {
  if (!travaLigada) return null

  return (
    <div
      role="note"
      style={{
        display: "flex", alignItems: "flex-start", gap: 9, padding: "10px 13px",
        background: "var(--acao-soft)", color: "var(--acao-on-soft)",
        borderBottom: "1px solid var(--acao)", fontSize: 11.5, lineHeight: 1.55,
      }}
    >
      <svg width="15" height="15" viewBox="0 0 24 24" aria-hidden="true"
           style={{ flex: "0 0 15px", marginTop: 1, fill: "none", stroke: "currentColor",
                    strokeWidth: 2, strokeLinecap: "round" }}>
        <path d="M12 8.5v5M12 17h.01" />
        <path d="M10.3 3.9 1.9 18.4A2 2 0 0 0 3.6 21.4h16.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
      </svg>
      <span>
        <b>Aqui só se grava registro de teste.</b> {oQueMuda} — e não há projeto canário para
        dado global. A trava deixa passar o que começa por <b>ZZTESTE</b>, e recusa o resto antes
        de sair. Ler e navegar funcionam normalmente; no ar, gravar também.
      </span>
    </div>
  )
}
